import {
    THEME_BLACK,
    THEME_GREY,
    THEME_PRIMARY,
    THEME_RED,
    THEME_SMOKY,
    THEME_WARNING,
    THEME_WHITE,
    themeColor
} from '../../../styles/basics/colors';

export const BUTTON_SIZE_SMALL = 'small';
export const BUTTON_SIZE_MEDIUM = 'medium';
export const BUTTON_SIZE_LARGE = 'large';

export const BUTTON_SIZES = [BUTTON_SIZE_SMALL, BUTTON_SIZE_MEDIUM, BUTTON_SIZE_LARGE];

export const BUTTON_THEME_EMPTY_GREEN = 'emptyGreen';
export const BUTTON_THEME_FULL_GREEN = 'fullGreen';
export const BUTTON_THEME_DEFAULT = 'default';
export const BUTTON_THEME_DANGER = 'danger';
export const BUTTON_THEME_EMPTY_ORANGE = 'emptyOrange';
export const BUTTON_THEME_EMPTY_RED = 'emptyRed';
export const BUTTON_THEME_FULL_RED = 'fullRed';
export const BUTTON_THEME_FULL_GREY = 'fullGrey';
export const BUTTON_THEME_ICON_GREEN = 'iconGreen';
export const BUTTON_THEME_ICON_BLACK = 'iconBlack';

export const ICON_BUTTON_THEMES = [BUTTON_THEME_ICON_GREEN, BUTTON_THEME_ICON_BLACK];

export const BUTTON_THEMES = [
    BUTTON_THEME_DEFAULT,
    BUTTON_THEME_DANGER,
    BUTTON_THEME_EMPTY_ORANGE,
    BUTTON_THEME_EMPTY_GREEN,
    BUTTON_THEME_FULL_GREEN,
    BUTTON_THEME_EMPTY_RED,
    BUTTON_THEME_FULL_RED,
    BUTTON_THEME_FULL_GREY
];

export const ButtonThemesStyles = {
    default: {
        icon: themeColor(THEME_PRIMARY),
        text: themeColor(THEME_BLACK),
        border: themeColor(THEME_SMOKY),
        background: themeColor(THEME_WHITE),
        hover: {
            icon: themeColor(THEME_WHITE),
            text: themeColor(THEME_WHITE),
            background: themeColor(THEME_PRIMARY),
            border: themeColor(THEME_PRIMARY)
        }
    },
    danger: {
        icon: themeColor(THEME_RED),
        text: themeColor(THEME_BLACK),
        background: themeColor(THEME_WHITE),
        border: themeColor(THEME_SMOKY),
        hover: {
            icon: themeColor(THEME_WHITE),
            text: themeColor(THEME_WHITE),
            border: themeColor(THEME_RED),
            background: themeColor(THEME_RED)
        }
    },
    emptyOrange: {
        icon: themeColor(THEME_WARNING),
        text: themeColor(THEME_WARNING),
        border: themeColor(THEME_WARNING),
        background: themeColor(THEME_WHITE),
        hover: {
            icon: themeColor(THEME_WHITE),
            text: themeColor(THEME_WHITE),
            background: themeColor(THEME_WARNING),
            border: themeColor(THEME_WARNING)
        }
    },
    fullGreen: {
        icon: themeColor(THEME_WHITE),
        text: themeColor(THEME_WHITE),
        background: themeColor(THEME_PRIMARY),
        border: themeColor(THEME_PRIMARY),
        hover: {
            icon: themeColor(THEME_PRIMARY),
            text: themeColor(THEME_PRIMARY),
            border: themeColor(THEME_PRIMARY),
            background: themeColor(THEME_WHITE)
        }
    },
    emptyGreen: {
        icon: themeColor(THEME_PRIMARY),
        text: themeColor(THEME_PRIMARY),
        background: themeColor(THEME_WHITE),
        border: themeColor(THEME_PRIMARY),
        hover: {
            icon: themeColor(THEME_WHITE),
            text: themeColor(THEME_WHITE),
            border: themeColor(THEME_PRIMARY),
            background: themeColor(THEME_PRIMARY)
        }
    },
    fullRed: {
        icon: themeColor(THEME_WHITE),
        text: themeColor(THEME_WHITE),
        background: themeColor(THEME_RED),
        border: themeColor(THEME_RED),
        hover: {
            icon: themeColor(THEME_RED),
            text: themeColor(THEME_RED),
            border: themeColor(THEME_RED),
            background: themeColor(THEME_WHITE)
        }
    },
    emptyRed: {
        icon: themeColor(THEME_RED),
        text: themeColor(THEME_RED),
        background: themeColor(THEME_WHITE),
        border: themeColor(THEME_RED),
        hover: {
            icon: themeColor(THEME_WHITE),
            text: themeColor(THEME_WHITE),
            border: themeColor(THEME_RED),
            background: themeColor(THEME_RED)
        }
    },
    fullGrey: {
        icon: themeColor(THEME_WHITE),
        text: themeColor(THEME_WHITE),
        background: themeColor(THEME_GREY),
        border: themeColor(THEME_GREY),
        hover: {
            icon: themeColor(THEME_WHITE),
            text: themeColor(THEME_WHITE),
            border: themeColor(THEME_GREY),
            background: themeColor(THEME_GREY)
        }
    }
};
